//quick reply
export const VERTICAL = 'vertical'

//webview
export const DYNAMIC = 'dynamic'
export const HTML = 'html'
export const WEBVIEW = 'webview'

//persistent menu
export const WEB_URL = 'web_url'
export const NESTED = 'nested'

//bot
export const PANORAMAPOST = 'panoramapost'
export const HORIZONPOST = 'horizonpost'
export const EMPOWERPRE = 'empowerpre'
export const EMPOWERPOST = 'empowerpost'

//payload
export const CLOSE_WIDGET_WITH_CONFIRMATION = 'Close widget with confirmation menu'

//browsers name
export const browserType = {
  EDGE: "edge",
  CHROME: "chrome",
  FIREFOX: "firefox",
  SAFARI: "safari",
  OPERA: "opera",
  UNKNOWN: "unknown"
}

export const persistentMenuItemType = {
  PERSISTENT_MENU_POSTBACK: 'PERSISTENT_MENU_POSTBACK',
  POSTBACK: 'postback'
}

export const buttonType = {
  POSTBACK: 'postback',
  WEB_URL: 'web_url',
  RESET: 'reset',
  DOWNLOAD: 'download',
  DOWNLOAD_IMAGE: 'download_image',
  SELECT_DATE: 'select_date',
  DROPDOWN: 'dropdown',
  RATING: 'rating'
}

export const attributeName = {
  IS_FILLED_QUICK_REPLY: 'is_filled_quick_reply',
  BUTTON_STYLE_TYPE: 'button_style_type',
  DOWNLOAD_IMAGE: 'download_image',
  PREVENT_DISABLE_QUESTIONNAIRE_BUTTON: 'prevent_disable_questionnaire_button',
  DROPDOWN_SELECT_NAME: 'dropdown_select_name',
  QUICK_REPLY_TYPE :'quick_reply_type'
}

export const attributeValue = {
  TRUE: 'true',
  PRIMARY: 'PRIMARY'
}

export const keyType = {
  ENTER: 'enter',
  ESCAPE: 'escape',
  TAB: 'tab',
  SPACE: ' '
}
